import React from 'react';
import { PageHero } from '../components/PageHero';
export function CookiePolicyPage() {
  return <>
      <PageHero title="Cookie Policy" data-id="element-677" />
      <section className="bg-white py-24" data-id="element-678">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 prose prose-lg text-steel-600" data-id="element-679">
          <p data-id="element-680">Last updated: February 2025</p>
          <h3 data-id="element-681">What Are Cookies?</h3>
          <p data-id="element-682">
            Cookies are small text files that are placed on your computer or
            mobile device by websites that you visit. They are widely used in
            order to make websites work, or work more efficiently, as well as to
            provide information to the owners of the site.
          </p>
          <h3 data-id="element-683">How We Use Cookies</h3>
          <p data-id="element-684">Chiltern Global uses cookies to:</p>
          <ul data-id="element-685">
            <li data-id="element-686">
              Understand how you use our website (e.g. which pages you visit).
            </li>
            <li data-id="element-687">Remember your preferences.</li>
            <li data-id="element-688">Improve your experience on our site.</li>
          </ul>
          <h3 data-id="element-689">Managing Cookies</h3>
          <p data-id="element-690">
            Most web browsers allow some control of most cookies through the
            browser settings. To find out more about cookies, including how to
            see what cookies have been set and how to manage and delete them,
            visit www.aboutcookies.org or www.allaboutcookies.org.
          </p>
        </div>
      </section>
    </>;
}